import { useEffect } from "react";
export default function useOnKeyPress(ref, handler, key) {
    useEffect(() => {
        const listener = (event) => {
            if (typeof key === "undefined" || event.key === key) {
                handler(event);
            }
        };
        document.addEventListener("keyup", listener);
        return () => {
            document.removeEventListener("keyup", listener);
        };
    }, [ref, handler, key]);
}
